import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';
import TimestampTooltip from '../../common/TimestampTooltip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    leftActionButton: {
      marginRight: 8
    }
  })
);

interface Props {
  tests: any[];
  page: number;
  onPageChange: (newPage: number) => void;
  onEditTest: (test: any) => void;
  onDownloadTest: (test: any) => void;
}

const headRows: HeadRow[] = [
  { id: 'name', disablePadding: true, label: 'Name' },
  { id: 'lastModified', disablePadding: false, label: 'Last Modified' },
  { id: 'actions', disablePadding: false, label: 'Actions' }
];

function TestsTable(props: Props) {
  const classes = useStyles({});
  const { tests, page, onPageChange, onEditTest, onDownloadTest } = props;
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('lastModified');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    onPageChange(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage);
  };

  const sortedRows = sortRows(tests, getSorting(order, orderBy));

  return (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={row.name}>
              <TableCell>
                {row.name}
              </TableCell>
              <TableCell>
                <TimestampTooltip timestamp={row.lastModified * 1000}>
                  <div>{moment(row.lastModified * 1000).fromNow()}</div>
                </TimestampTooltip>
              </TableCell>
              <TableCell>
                <Tooltip title="Upload new test package" className={classes.leftActionButton}>
                  <IconButton size="small" onClick={() => onEditTest(row)}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Download test package">
                  <IconButton size="small" onClick={() => onDownloadTest(row)}>
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={tests.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default TestsTable;
